var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.288,
    height: 21.122,
    viewBox: "0 0 17.288 21.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.499 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M134.125,131.516a.742.742,0,0,0-.521-.214.732.732,0,0,0-.521.214L130.5,134.1l-.891-.892a.737.737,0,0,0-1.042,1.044l1.413,1.413a.732.732,0,0,0,.521.214h0a.733.733,0,0,0,.521-.214l3.1-3.1A.738.738,0,0,0,134.125,131.516Z",
    transform: "translate(-90.198 -123.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.752,4.353a.383.383,0,0,0-.214-.312l-8.227-4a.383.383,0,0,0-.336,0l-8.227,4a.383.383,0,0,0-.214.312,21.185,21.185,0,0,0,.662,6.51,17.448,17.448,0,0,0,2.45,5.517,14.434,14.434,0,0,0,5.32,4.7.383.383,0,0,0,.353,0,14.434,14.434,0,0,0,5.32-4.7,17.446,17.446,0,0,0,2.45-5.517A21.185,21.185,0,0,0,49.752,4.353Zm-8.609,10.5A4.877,4.877,0,1,1,46.02,9.971,4.883,4.883,0,0,1,41.143,14.848Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.b5336b4fdf8fb0015864199f6e864d35.svg";
export { ForwardRef as ReactComponent };